<template>
	<PopupRouterView :showLeftIcon="true" label="Approval Structure Input"  entityName="approvalstructure" :documentId="mainRecordId"  @saveMethod="saveActionConfirmation" @hideMethod="onHidden">
		<b-card>
			<b-col cols="12" lg="6">
				<app-input-textbox id="fieldset-name" label-cols-sm="4" label-cols-lg="3" label="Structure Name" label-for="input-name" size="sm" :model.sync="model.name"   />
				<app-input-textarea id="fieldset-description" label-cols-sm="4" label-cols-lg="3" label="Description" label-for="input-description" size="sm" :model.sync="model.description"   />
				<app-input-combobox-autocomplete :options="approvalStructures" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Parent Structure" id="input-" size="sm" :model.sync="model.parentId"  :selected="model.parent != null ? model.parent.name : ''" @input="getApprovalStructures" @change="setSelectedParent" />
			</b-col>
			<b-col>
				<span class="float-right" v-if="modelId != null && modelId != undefined && modelId != ''">
					<b-button variant="success" class="float-right ml-2" @click="downloadData" size="sm"><b-icon-download class="mr-1"></b-icon-download> Download</b-button>
				</span>
			</b-col>
		</b-card>
		<PopupConfirmationDetail :openPopup="isShowPopupConfirmation" :model="model" @saveActionMethod="saveAction" @resetMethod="resetModal" />
		<b-overlay :show="isBusy" no-wrap></b-overlay>
	</PopupRouterView>
</template>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import ApprovalStructure from '@/models/ApprovalStructure/ApprovalStructure';
import ApprovalStructureList from '@/models/ApprovalStructure/ApprovalStructureList';
import ApprovalStructureFilter from '@/filters/ApprovalStructure/ApprovalStructureFilter';

import PopupConfirmationDetail from './PopupConfirmationDetail';

import AppInputTextbox from '@/components/AppInputTextbox';
import AppInputTextarea from '@/components/AppInputTextarea';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	components : {AppInputTextbox,AppInputTextarea,AppInputComboboxAutocomplete,PopupRouterView,PopupConfirmationDetail},
	mixins : [validationMixin],
	validations: {
		model: {
		}
	},
	data() {
		return {
			errorMessage : {
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			filterApprovalStructure : null,
			currentApprovalStructurePage : 1,
			approvalStructurePageSize: 10,
			sortByApprovalStructure: '',
			sortDescApprovalStructure: '',
			approvalStructures: [],
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
		}
	},
	methods : {
		getApprovalStructure : async function(id) {
			this.isBusy = true;
			ApprovalStructure.getData(this, id).then(result => { this.model = result; this.mainRecordId = String(result.mainRecordId); this.isBusy = false; }).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadApprovalStructure = true;
			this.filterApprovalStructure.id = this.modelId;
			ApprovalStructure.downloadDataDetail(this, this.filterApprovalStructure).then(result => {
				this.isDownloadApprovalStructure = false;
			}).catch(error => { this.isDownloadApprovalStructure = false; })
		},
		getApprovalStructures : async function(input) {
			let filter = new ApprovalStructureFilter();
			if (input != undefined) {
				filter.name = input;
			}
			ApprovalStructure.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.approvalStructures = result.data
				}
			})
			.catch(error => {});
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		saveActionConfirmation(modalEvent) {
			modalEvent.preventDefault();
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isShowPopupConfirmation = true;
			}
		},
		saveAction(modalEvent) {
			this.isBusy = true;
			let id = this.modelId;
			let model = this.model;

			if (id != '' && id != null && id != undefined) {
				ApprovalStructure.updateData(this, model, id).then(result => {
					this.isDataCommited = true;
					this.$router.push({ name: 'approvalstructureindex' });
					this.isBusy = false;
				}).catch(error => { this.isBusy = false; });
			} else {
				ApprovalStructure.insertData(this, model).then(result => {
					this.$router.push({ name: 'approvalstructureindex' });
					this.isBusy = false;
				}).catch(error => { this.isBusy = false; });
			}
		},
		onHidden() {
			this.getApprovalStructures();
		},
		resetModal(modalType) {
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
			}
		},
		setSelectedParent(item) {
			console.log(this.model.parentId);
			console.log(this.model)
			let parentId = this.model.parentId;
			let parentObj = this.approvalStructures.filter(function(itemObj){ return itemObj.id == parentId; });
			console.log(parentObj);
			this.model.parent = parentObj.length > 0 ? parentObj[0] : null;
			this.model.parentName = parentObj.length > 0 ? parentObj[0].Name : null;
			console.log(this.model.parent);
		},
	},
	beforeMount() {
		this.filterApprovalStructure = new ApprovalStructureFilter();
		this.getApprovalStructures();
	},
	async mounted(){
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getApprovalStructure(id);
			} else {
				this.modelId = id;
				this.getApprovalStructure(id);
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
	},
	watch : {
	},
	beforeDestroy() {
	},
}
</script>
